import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Course from '../Shared/Courses/Course';

const CoursesPages = () => {
    const courseData = useLoaderData()
    return (
        <section className='container py-5'>
            <div className="row mb-3">
						<div className="col-md-6 offset-md-3 bg-black rounded py-3 text-white text-center">
							<h2 className="fw-bolder">Our popular Courses</h2>
                            <p className="fw-bold mb-0">Discover Our Popular Courses on specail discount</p>
						</div>
					</div>
            <div className="row">
            {courseData.map(course=> <Course key={course.id} course={course}></Course>)}
            </div>
        </section>
    );
};

export default CoursesPages;